module.exports = __webpack_public_path__ + "img/finalforms.9813d848.png";